import React from 'react';

const Icon: React.FC<any> = ({ className, ...props }) => (
  <svg
    className={className}
    {...props}
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width={11} height={11} rx="5.5" stroke="black" />
    <path
      d="M5.42857 5.92857H5.92857V5.42857V2.5H6.07143V5.42857V5.92857H6.57143H9.5V6.07143H6.57143H6.07143V6.57143V9.5H5.92857V6.57143V6.07143H5.42857H2.5V5.92857H5.42857Z"
      fill="#191919"
      stroke="black"
    />
  </svg>
);

export default Icon;
